import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e5b676f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wrap"
}
const _hoisted_2 = { class: "inner" }
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { colspan: "2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "⁺", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_9 = { class: "nowrap" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "⁺", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "HKD257,600", -1))
const _hoisted_12 = { class: "nowrap" }
const _hoisted_13 = { class: "nowrap" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "HKD2,200", -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode("HKD259,313.87")
const _hoisted_16 = { class: "link" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "^", -1))
const _hoisted_18 = { colspan: "2" }
const _hoisted_19 = {
  key: 0,
  class: "footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t_button = _resolveComponent("t-button")!
  const _component_t_icon = _resolveComponent("t-icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.modelValue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "mask",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onTapByClose && _ctx.onTapByClose(...args)))
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h3", {
                  class: _normalizeClass({ eng: _ctx.isEng })
                }, _toDisplayString(_ctx.$t('「先租后付」例子：')), 3),
                _createElementVNode("table", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_5, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('每月租金HKD20,000；')), 1),
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('原1年租屋开支')), 1),
                        _hoisted_6,
                        _createTextVNode(_toDisplayString(_ctx.$t('为')) + "HKD280,000" + _toDisplayString(_ctx.$t('。')), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_7,
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t('用「先租后付」')), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_8,
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t('透过「个人信用额度」即时预缴1年租金，业主减租8%至HKD18,400*。')), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_9, [
                      _createTextVNode(_toDisplayString(_ctx.$t('1年租屋开支')), 1),
                      _hoisted_10,
                      _createTextVNode(_toDisplayString(_ctx.$t('：')), 1)
                    ]),
                    _hoisted_11
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.$t('+贷款利息：')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t('若还款期为12个月及实际年利率为2.84% (使用6折优惠券后)，总利息=HKD3,913.87')), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.$t('-计划奖赏：')), 1),
                    _hoisted_14
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('总开支')), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('=1年租屋开支+按金+贷款利息-计划奖赏')), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _hoisted_15,
                      _createElementVNode("p", _hoisted_16, [
                        _createTextVNode(_toDisplayString(_ctx.$t('合共节省7.4%,即')) + "HKD20,686.13", 1),
                        _hoisted_17,
                        _createTextVNode(_toDisplayString(_ctx.$t('！')), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_18, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('* 预缴1年租金可提升的议价空间根据个别业主愿意提供折扣的程度而定。业主及租客之间的租赁安排及租赁协议与富融银行无关，富融银行亦不承担任何义务、责任或法律责任。')), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('+ 1年租屋开支为12个月租金加2个月按金，即14个月租金。')), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('^ 对比原1年租屋开支HKD280,000。7.4%已约至小数点后1个位。')), 1)
                    ])
                  ])
                ]),
                _renderSlot(_ctx.$slots, "content", {}, undefined, true)
              ]),
              (_ctx.footer)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_component_t_button, {
                      text: _ctx.confirmText,
                      onClick: _ctx.onTapByClose,
                      theme: "primary",
                      size: "small"
                    }, null, 8, ["text", "onClick"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: "close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onTapByClose && _ctx.onTapByClose(...args)))
            }, [
              _createVNode(_component_t_icon, {
                theme: "highlight",
                "icon-name": "close-circle-outline"
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}